<template>
  <div class="logoregister ">
    <headd></headd>
    <indexswiper :swiper_list="swiper_list"></indexswiper>
    <div class="logoregister_mo container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_11.png" />
          </div>
          商标注册申请
        </div>
      </div>
      <modulelist1 :modulelist="combos"></modulelist1>
    </div>
    <div class="reviewcase container">
      <div class="re_head">
        <div class="re_icon">
          <img src="../../static/otherpage/icon_6.png" />
        </div>
        <div class="re_title">商标驳回复审<span>是什么？</span></div>
      </div>
      <div class="re_con">
        <!-- <img class="image" :src="dy_title_t1.pagevalue" mode="widthFix" /> -->
        <img
          :src="dy_title_t1.pagevalue"
          class="hidden-lg hidden-md image"
          mode="widthFix"
        />
        <img
          :src="dy_title_t1.pagevaluepc"
          class="hidden-xs hidden-sm image"
          mode="widthFix"
        />
        <!-- 商标被驳回后，如果被判决不服，可以在收到驳文的15日内向商评委申请复审。如果不复审，本次商标注册则会失败，前期耗费的人力、物力、财力全都白费。 -->
      </div>
    </div>

    <div class="logoregister_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_10.png" />
          </div>
          商标驳回复审
        </div>
      </div>
      <modulelist3 :modulelist="ServiceBackCombo"></modulelist3>
    </div>
    <div class="reviewcase container">
      <div class="re_head">
        <div class="re_icon">
          <img src="../../static/otherpage/icon_6.png" />
        </div>
        <div class="re_title">为什么需要做<span>驳回复审？</span></div>
      </div>
      <div class="re_con">
        <!-- <img class="image" :src="dy_title_t2.pagevalue" mode="widthFix" /> -->
        <img
          :src="dy_title_t2.pagevalue"
          class="hidden-lg hidden-md image"
          mode="widthFix"
        />
        <img
          :src="dy_title_t2.pagevaluepc"
          class="hidden-xs hidden-sm image"
          mode="widthFix"
        />
      </div>
    </div>
    <div class="logoregister_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_1.png" />
          </div>
          热门推荐
        </div>
      </div>
      <modulelist2 :modulelist="HotCombo" :is_show="is_show"></modulelist2>
    </div>
    <dynamicimg :datainfo="dy_title_t3"></dynamicimg>
    <maybe :is_include="name"></maybe>
    <foot></foot>
  </div>
</template>

<script>
import indexswiper from "../components/indexswiper.vue";
import indexbanner from "../components/indexbanner.vue";
import maybe from "../components/maybe.vue";
import anews from "../components/anews.vue";
import dynamicimg from "../components/dynamicimg.vue";
import modulelist1 from "../components/modulelist1.vue";
import modulelist2 from "../components/modulelist2.vue";
import modulelist3 from "../components/modulelist3.vue";
import headd from "../components/head";
import foot from "@/components/foot";
import {
  getshangbiaoCombobanner,
  getshangbiaoCombo,
  getshangbiaoServiceBackCombo,
  getshangbiaoServiceHotCombo,
  getshangbiaoPageData
} from "./api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      name: "代理记账",

      dy_title_t1: {
        icon: "../../static/otherpage/icon_6.png",
        title: "",
        pagevalue: ""
      },
      dy_title_t2: {
        icon: "../../static/otherpage/icon_t_9.png",
        title: "",
        pagevalue: ""
      },
      dy_title_t3: {
        icon: "../../static/otherpage/icon_t_8.png",
        title: "",
        pagevalue: ""
      },
      indicatorDots: true,
      autoplay: true,
      interval: 2000,
      duration: 500,
      indicatorColor: "rgba(255, 255, 255, .3)",
      indicatorActivecolor: "#FFFFFF",
      texts: "测试数据",
      swiper_list: [],
      combos: [],
      ServiceBackCombo: [],
      HotCombo: [],
      adbanner_list: [],

      is_show: true
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexbanner,
    indexswiper,
    maybe,
    anews,
    dynamicimg,
    modulelist1,
    modulelist2,
    modulelist3,
    headd,
    foot
  },
  async mounted() {
    var swiperr = await getshangbiaoCombobanner();
    this.swiper_list = swiperr.data.data.banner;
    this.$nextTick(function() {
      this.swiper();
    });
    var combos = await getshangbiaoCombo();
    this.combos = combos.data.data.combos;
    var ServiceBackCombo = await getshangbiaoServiceBackCombo();
    this.ServiceBackCombo = ServiceBackCombo.data.data.combos;
    var HotCombo = await getshangbiaoServiceHotCombo();
    this.HotCombo = HotCombo.data.data.combos;

    var regPageData = await getshangbiaoPageData();
    var data = regPageData.data.data;

    this.dy_title_t1 = data.t1;
    this.dy_title_t2 = data.t2;
    this.dy_title_t3 = data.t3;
    this.$set(this.dy_title_t1, "icon", "../../static/otherpage/icon_t_6.png");
    this.$set(this.dy_title_t2, "icon", "../../static/otherpage/icon_t_9.png");
    this.$set(this.dy_title_t3, "icon", "../../static/otherpage/icon_t_8.png");
  },
  methods: {
    swiper() {
      new Swiper(".banner", {
        loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000
      });
    }
  }
};
</script>

<style lang="less">
.container {
  margin: 30rpx 32rpx;
  width: 686rpx;
}

.logoregister {
  flex-direction: column;
  @media (max-width: 991px) {
    width: 6.86rem;
  }
  margin: auto;
  .logoregister_mo {
    flex-direction: column;
    margin-bottom: 20rpx;
  }

  .logoregister_recommd {
    flex-direction: column;
  }
  .reviewcase {
    padding: 0.35rem 0.28rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/logoregister.vue